import React from 'react';
import { Link } from 'react-router-dom';

const CookiePolicyPage = () => {
  return (
    <div className="cookie-policy-page container mx-auto px-4 py-12 max-w-4xl">
      <h1 className="text-3xl font-bold mb-8 text-center">Cookie Policy</h1>
      
      <div className="text-base text-white leading-relaxed">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">What Are Cookies</h2>
          <p className="mb-4">
            Cookies are small text files that are placed on your computer or mobile device when you visit 
            a website. They are widely used to make websites work more efficiently and provide information 
            to the owners of the site. Cookies enhance your browsing experience by allowing websites to 
            remember your preferences, understand how you use the website, and even customise the content 
            you see.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">How We Use Cookies</h2>
          <p className="mb-4">
            At Zahoot-AI, we use cookies for various purposes. We've categorized our cookies to help you 
            understand why we use them and to give you control over which types you accept.
          </p>
          
          <div className="mt-6 mb-4">
            <h3 className="text-xl font-semibold mb-2">Necessary Cookies</h3>
            <p className="mb-4">
              These cookies are essential for the website to function properly. They enable basic functions 
              like page navigation, secure areas of the website, and access to protected features. The website 
              cannot function properly without these cookies, and they cannot be switched off in our systems.
            </p>
            <table className="w-full border-collapse mb-6">
              <thead>
                <tr className="bg-gray-700">
                  <th className="border border-gray-600 px-4 py-2 text-left">Cookie Name</th>
                  <th className="border border-gray-600 px-4 py-2 text-left">Purpose</th>
                  <th className="border border-gray-600 px-4 py-2 text-left">Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-600 px-4 py-2">sessionid</td>
                  <td className="border border-gray-600 px-4 py-2">Maintains your session while logged in</td>
                  <td className="border border-gray-600 px-4 py-2">Session</td>
                </tr>
                <tr>
                  <td className="border border-gray-600 px-4 py-2">csrftoken</td>
                  <td className="border border-gray-600 px-4 py-2">Helps prevent Cross-Site Request Forgery attacks</td>
                  <td className="border border-gray-600 px-4 py-2">1 year</td>
                </tr>
                <tr>
                  <td className="border border-gray-600 px-4 py-2">cookieConsent</td>
                  <td className="border border-gray-600 px-4 py-2">Stores your cookie preferences</td>
                  <td className="border border-gray-600 px-4 py-2">1 year</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div className="mt-6 mb-4">
            <h3 className="text-xl font-semibold mb-2">Analytics Cookies</h3>
            <p className="mb-4">
              These cookies allow us to count visits and traffic sources, so we can measure and improve the 
              performance of our site. They help us understand which pages are the most and least popular, 
              and see how visitors move around the site. All information these cookies collect is aggregated 
              and therefore anonymous.
            </p>
            <table className="w-full border-collapse mb-6">
              <thead>
                <tr className="bg-gray-700">
                  <th className="border border-gray-600 px-4 py-2 text-left">Cookie Name</th>
                  <th className="border border-gray-600 px-4 py-2 text-left">Purpose</th>
                  <th className="border border-gray-600 px-4 py-2 text-left">Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-600 px-4 py-2">_ga</td>
                  <td className="border border-gray-600 px-4 py-2">Used by Google Analytics to distinguish users</td>
                  <td className="border border-gray-600 px-4 py-2">2 years</td>
                </tr>
                <tr>
                  <td className="border border-gray-600 px-4 py-2">_gid</td>
                  <td className="border border-gray-600 px-4 py-2">Used by Google Analytics to distinguish users</td>
                  <td className="border border-gray-600 px-4 py-2">24 hours</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div className="mt-6 mb-4">
            <h3 className="text-xl font-semibold mb-2">Marketing Cookies</h3>
            <p className="mb-4">
              These cookies are used to track visitors across websites. The intention is to display ads that 
              are relevant and engaging for the individual user. These cookies may be set through our site by 
              our advertising partners.
            </p>
            <table className="w-full border-collapse mb-6">
              <thead>
                <tr className="bg-gray-700">
                  <th className="border border-gray-600 px-4 py-2 text-left">Cookie Name</th>
                  <th className="border border-gray-600 px-4 py-2 text-left">Purpose</th>
                  <th className="border border-gray-600 px-4 py-2 text-left">Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-600 px-4 py-2">_fbp</td>
                  <td className="border border-gray-600 px-4 py-2">Used by Facebook to deliver advertisements</td>
                  <td className="border border-gray-600 px-4 py-2">3 months</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div className="mt-6 mb-4">
            <h3 className="text-xl font-semibold mb-2">Preference Cookies</h3>
            <p className="mb-4">
              These cookies enable the website to remember information that changes the way the website behaves 
              or looks, like your preferred language or the region you are in.
            </p>
            <table className="w-full border-collapse mb-6">
              <thead>
                <tr className="bg-gray-700">
                  <th className="border border-gray-600 px-4 py-2 text-left">Cookie Name</th>
                  <th className="border border-gray-600 px-4 py-2 text-left">Purpose</th>
                  <th className="border border-gray-600 px-4 py-2 text-left">Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-600 px-4 py-2">lang</td>
                  <td className="border border-gray-600 px-4 py-2">Remembers the user's selected language</td>
                  <td className="border border-gray-600 px-4 py-2">1 year</td>
                </tr>
                <tr>
                  <td className="border border-gray-600 px-4 py-2">theme</td>
                  <td className="border border-gray-600 px-4 py-2">Stores the user's preferred theme (light/dark)</td>
                  <td className="border border-gray-600 px-4 py-2">1 year</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Controlling Cookies</h2>
          <p className="mb-4">
            When you first visit our website, you'll see a cookie banner giving you the option to accept or 
            decline different types of cookies. You can always change your preferences by clearing your browser 
            cookies and visiting our site again.
          </p>
          <p className="mb-4">
            Additionally, most web browsers allow you to control cookies through their settings. You can find 
            more information about cookies and how to manage them in your browser here:
          </p>
          <ul className="list-disc pl-6 mt-2 mb-4 space-y-2">
            <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">Google Chrome</a></li>
            <li><a href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">Mozilla Firefox</a></li>
            <li><a href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">Safari</a></li>
            <li><a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">Microsoft Edge</a></li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Changes to This Cookie Policy</h2>
          <p className="mb-4">
            We may update our Cookie Policy from time to time. We will notify you of any changes by posting 
            the new Cookie Policy on this page. You are advised to review this Cookie Policy periodically for 
            any changes.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
          <p className="mb-4">
            If you have any questions about our Cookie Policy, please contact us at:
          </p>
          <p className="font-medium mt-2">
            Email: support@zahoot.ai<br />
            Phone: +44 121 630 0000
          </p>
          <p className="mt-4">
            <Link to="/privacy-policy" className="text-blue-400 hover:underline">View our Privacy Policy</Link>
          </p>
        </section>
      </div>
    </div>
  );
};

export default CookiePolicyPage; 